import React from "react";

export const IconSearch = ({ w, h, c }) => {
  return (
    <svg
      width={w || "20"}
      height={h || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.58317 17.5C13.9554 17.5 17.4998 13.9556 17.4998 9.58335C17.4998 5.2111 13.9554 1.66669 9.58317 1.66669C5.21092 1.66669 1.6665 5.2111 1.6665 9.58335C1.6665 13.9556 5.21092 17.5 9.58317 17.5Z"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3332 18.3334L16.6665 16.6667"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const IconHome = ({ w, h, c }) => {
  return (
    <svg
      width={w || "20"}
      height={h || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.51675 2.36664L3.02508 5.86664C2.27508 6.44997 1.66675 7.69164 1.66675 8.63331V14.8083C1.66675 16.7416 3.24175 18.325 5.17508 18.325H14.8251C16.7584 18.325 18.3334 16.7416 18.3334 14.8166V8.74997C18.3334 7.74164 17.6584 6.44997 16.8334 5.87497L11.6834 2.26664C10.5167 1.44997 8.64175 1.49164 7.51675 2.36664Z"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 14.9916V12.4916V14.9916Z" fill="white" />
      <path
        d="M10 14.9916V12.4916"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconOrder = ({ w, h, c }) => {
  return (
    <svg
      width={w || "20"}
      height={h || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.6665 1.66669V4.16669"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3335 1.66669V4.16669"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.9165 7.57501H17.0832"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3332 15.8333C18.3332 16.4583 18.1582 17.05 17.8498 17.55C17.2748 18.5167 16.2165 19.1667 14.9998 19.1667C14.1582 19.1667 13.3915 18.8583 12.8082 18.3333C12.5498 18.1167 12.3248 17.85 12.1498 17.55C11.8415 17.05 11.6665 16.4583 11.6665 15.8333C11.6665 13.9917 13.1582 12.5 14.9998 12.5C15.9998 12.5 16.8915 12.9417 17.4998 13.6333C18.0165 14.225 18.3332 14.9917 18.3332 15.8333Z"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6997 15.8333L14.5247 16.6583L16.2997 15.0167"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 7.08335V13.6333C16.8917 12.9417 16 12.5 15 12.5C13.1583 12.5 11.6667 13.9917 11.6667 15.8334C11.6667 16.4584 11.8417 17.05 12.15 17.55C12.325 17.85 12.55 18.1167 12.8083 18.3334H6.66667C3.75 18.3334 2.5 16.6667 2.5 14.1667V7.08335C2.5 4.58335 3.75 2.91669 6.66667 2.91669H13.3333C16.25 2.91669 17.5 4.58335 17.5 7.08335Z"
        stroke={c || "currentColor"}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99607 11.4167H10.0036"
        stroke={c || "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.91209 11.4167H6.91957"
        stroke={c || "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.91209 13.9167H6.91957"
        stroke={c || "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconBell = ({ w, h, c }) => {
  return (
    <svg
      width={w || "20"}
      height={h || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0165 2.42499C7.25816 2.42499 5.0165 4.66665 5.0165 7.42499V9.83332C5.0165 10.3417 4.79983 11.1167 4.5415 11.55L3.58316 13.1417C2.9915 14.125 3.39983 15.2167 4.48316 15.5833C8.07483 16.7833 11.9498 16.7833 15.5415 15.5833C16.5498 15.25 16.9915 14.0583 16.4415 13.1417L15.4832 11.55C15.2332 11.1167 15.0165 10.3417 15.0165 9.83332V7.42499C15.0165 4.67499 12.7665 2.42499 10.0165 2.42499Z"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.5584 2.66664C11.3001 2.59164 11.0334 2.5333 10.7584 2.49997C9.95843 2.39997 9.19176 2.4583 8.4751 2.66664C8.71676 2.04997 9.31676 1.61664 10.0168 1.61664C10.7168 1.61664 11.3168 2.04997 11.5584 2.66664Z"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5166 15.8834C12.5166 17.2584 11.3916 18.3834 10.0166 18.3834C9.33327 18.3834 8.69993 18.1 8.24993 17.65C7.79993 17.2 7.5166 16.5667 7.5166 15.8834"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const IconCart = ({ w, h, c }) => {
  return (
    <svg
      width={w || "20"}
      height={w || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6665 1.66669H3.11651C4.01651 1.66669 4.72484 2.44169 4.64984 3.33335L3.95817 11.6333C3.8415 12.9917 4.9165 14.1583 6.28317 14.1583H15.1582C16.3582 14.1583 17.4082 13.175 17.4998 11.9834L17.9498 5.73336C18.0498 4.35002 16.9998 3.22502 15.6082 3.22502H4.84984"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5417 18.3333C14.117 18.3333 14.5833 17.867 14.5833 17.2917C14.5833 16.7164 14.117 16.25 13.5417 16.25C12.9664 16.25 12.5 16.7164 12.5 17.2917C12.5 17.867 12.9664 18.3333 13.5417 18.3333Z"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.87516 18.3333C7.45046 18.3333 7.91683 17.867 7.91683 17.2917C7.91683 16.7164 7.45046 16.25 6.87516 16.25C6.29987 16.25 5.8335 16.7164 5.8335 17.2917C5.8335 17.867 6.29987 18.3333 6.87516 18.3333Z"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 6.66669H17.5"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconUser = ({ w, h, c }) => {
  return (
    <svg
      width={w || "24"}
      height={h || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5901 22C20.5901 18.13 16.7402 15 12.0002 15C7.26015 15 3.41016 18.13 3.41016 22"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const IconBox = ({ w, h, c }) => {
  return (
    <svg
      width={w || "24"}
      height={h || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.16992 7.43994L11.9999 12.5499L20.7699 7.46994"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 21.61V12.54"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.93014 2.48004L4.59014 5.44004C3.38014 6.11004 2.39014 7.79004 2.39014 9.17004V14.82C2.39014 16.2 3.38014 17.88 4.59014 18.55L9.93014 21.52C11.0701 22.15 12.9401 22.15 14.0801 21.52L19.4201 18.55C20.6301 17.88 21.6201 16.2 21.6201 14.82V9.17004C21.6201 7.79004 20.6301 6.11004 19.4201 5.44004L14.0801 2.47004C12.9301 1.84004 11.0701 1.84004 9.93014 2.48004Z"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconSetting = ({ w, h, c }) => {
  return (
    <svg
      width={w || "24"}
      height={h || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12.8801V11.1201C2 10.0801 2.85 9.22006 3.9 9.22006C5.71 9.22006 6.45 7.94006 5.54 6.37006C5.02 5.47006 5.33 4.30006 6.24 3.78006L7.97 2.79006C8.76 2.32006 9.78 2.60006 10.25 3.39006L10.36 3.58006C11.26 5.15006 12.74 5.15006 13.65 3.58006L13.76 3.39006C14.23 2.60006 15.25 2.32006 16.04 2.79006L17.77 3.78006C18.68 4.30006 18.99 5.47006 18.47 6.37006C17.56 7.94006 18.3 9.22006 20.11 9.22006C21.15 9.22006 22.01 10.0701 22.01 11.1201V12.8801C22.01 13.9201 21.16 14.7801 20.11 14.7801C18.3 14.7801 17.56 16.0601 18.47 17.6301C18.99 18.5401 18.68 19.7001 17.77 20.2201L16.04 21.2101C15.25 21.6801 14.23 21.4001 13.76 20.6101L13.65 20.4201C12.75 18.8501 11.27 18.8501 10.36 20.4201L10.25 20.6101C9.78 21.4001 8.76 21.6801 7.97 21.2101L6.24 20.2201C5.33 19.7001 5.02 18.5301 5.54 17.6301C6.45 16.0601 5.71 14.7801 3.9 14.7801C2.85 14.7801 2 13.9201 2 12.8801Z"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconLogout = ({ w, h, c }) => {
  return (
    <svg
      width={w || "24"}
      height={h || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4399 14.62L19.9999 12.06L17.4399 9.5"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75977 12.06H19.9298"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7598 20C7.33977 20 3.75977 17 3.75977 12C3.75977 7 7.33977 4 11.7598 4"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconHemberger = ({ w, h, c }) => {
  return (
    <svg
      width={w || "24"}
      height={h || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 7H21"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 12H21"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 17H21"
        stroke={c || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const IconCheck = ({ w, h, c }) => {
  return (
    <svg
      width={w || "17"}
      height={h || "16"}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33366 1.33334C4.66033 1.33334 1.66699 4.32668 1.66699 8.00001C1.66699 11.6733 4.66033 14.6667 8.33366 14.6667C12.007 14.6667 15.0003 11.6733 15.0003 8.00001C15.0003 4.32668 12.007 1.33334 8.33366 1.33334ZM11.5203 6.46668L7.74033 10.2467C7.64699 10.34 7.52033 10.3933 7.38699 10.3933C7.25366 10.3933 7.12699 10.34 7.03366 10.2467L5.14699 8.36001C4.95366 8.16668 4.95366 7.84668 5.14699 7.65334C5.34033 7.46001 5.66033 7.46001 5.85366 7.65334L7.38699 9.18668L10.8137 5.76001C11.007 5.56668 11.327 5.56668 11.5203 5.76001C11.7137 5.95334 11.7137 6.26668 11.5203 6.46668Z"
        fill={c === "green" ? "#12B886" : c || "currentColor"}
      />
    </svg>
  );
};
